// Copyright (c) 2017 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../shared/action-creators/get-claim-types';
import actions from '../../actions-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPES);



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/action-creators/get-claim-types.js